import { render, staticRenderFns } from "./No20.vue?vue&type=template&id=5f98fe84&scoped=true"
import script from "./No20.vue?vue&type=script&lang=js"
export * from "./No20.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f98fe84",
  null
  
)

export default component.exports